if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        let productPageUrl  = opener.getAttribute('data-product-url');

        if (productPageUrl) {
          const urlSeparator = productPageUrl.includes('?') ? '&' : '?';
          productPageUrl = `${productPageUrl}${urlSeparator}section_id=product-quick-add-info`;
        }

        fetch(productPageUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-quick-add-info') || responseHTML.querySelector('product-info');

            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
    }
  );
}

if (!customElements.get('product-quick-add-info')) {
  customElements.define(
    'product-quick-add-info',
    class ProductQuickAddInfo extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initMediaSlider();
        this.loadReviews();
      }

      async initMediaSlider() {
        const mediaSlider = this.querySelector('.product-quick-add__media-slider');
        if (!mediaSlider) return;

        const Swiper = await window.pfLoadSwiper().catch(() => null);
        if (!Swiper || !mediaSlider.isConnected) return;

        const mediaSliderSwiper = new Swiper(mediaSlider, {
          slidesPerView: '1',
          spaceBetween: 10,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }

      async loadReviews() {
        const reviewsData = await this.getReviewsData();
        if (!reviewsData) return;

        const { bottomline, reviews } = reviewsData;

        const starRatings = this.querySelectorAll('.product-quick-add__star-rating');
        starRatings.forEach((starRating) => {
          starRating.innerHTML = `
            <div class="stars${bottomline.averageScore > 0 ? '' : ' empty-stars'}">
              ${this.getStarsHTML(bottomline.averageScore)}
            </div>
            <div class="reviews-count">
              ${bottomline.totalReview} Reviews
            </div>
          `;
        });

        const reviewsWidget = this.querySelectorAll('.product-quick-add__reviews-widget');
        reviewsWidget.forEach((widget) => {
          if (reviews.length) {
            widget.innerHTML = `
              <div class="product-quick-add__reviews-slider swiper">
                <div class="swiper-wrapper">
                  ${this.getReviewsHTML(reviews)}
                </div>
                <div class="swiper-pagination"></div>
              </div>
            `;
          } else {
            widget.innerHTML = `<div class="product-quick-add__no-reviews">Be the first to write a review</div>`;
          }
        });

        const reviewSlider = this.querySelector('.product-quick-add__reviews-slider');
        if (!reviewSlider) return;

        const Swiper = await window.pfLoadSwiper().catch(() => null);
        if (!Swiper || !reviewSlider.isConnected) return;

        const reviewSliderSwiper = new Swiper(reviewSlider, {
          slidesPerView: '1',
          spaceBetween: 10,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
      }

      getStarsHTML(score) {
        const roundedScore = this.roundRating(score);

        let starsHTML = '';

        for (let i = 1; i <= 5; i++) {
          if (i <= roundedScore) {
            // Filled star
            starsHTML += `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M14.1401 12.2139L13.9202 12.4105L13.9859 12.698L15.4052 18.9118L10.2712 15.59L10.0001 15.4147L9.72875 15.5895L4.57086 18.9128L6.00718 12.6925L6.07358 12.405L5.85394 12.2079L1.20147 8.033L7.27284 7.55177L7.5846 7.52706L7.69881 7.23591L10 1.36925L12.3012 7.23591L12.415 7.52617L12.7258 7.55166L18.7987 8.04981L14.1401 12.2139Z" fill="currentColor" stroke="currentColor"/></svg>`;
          } else if (i - 0.5 === roundedScore) {
            // Half-filled star
            starsHTML += `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M14.1401 12.2139L13.9202 12.4105L13.9859 12.698L15.4052 18.9118L10.2712 15.59L10.0001 15.4147L9.72875 15.5895L4.57086 18.9128L6.00718 12.6925L6.07358 12.405L5.85394 12.2079L1.20147 8.033L7.27284 7.55177L7.5846 7.52706L7.69881 7.23591L10 1.36925L12.3012 7.23591L12.415 7.52617L12.7258 7.55166L18.7987 8.04981L14.1401 12.2139Z" fill="none" stroke="currentColor"/>
              <path d="M10 0L7.23333 7.05333L0 7.62667L5.52 12.58L3.80667 20L9.99956 16.0098L10 0Z" fill="currentColor"/></svg>`;
          } else {
            // Empty star
            starsHTML += `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M14.1401 12.2139L13.9202 12.4105L13.9859 12.698L15.4052 18.9118L10.2712 15.59L10.0001 15.4147L9.72875 15.5895L4.57086 18.9128L6.00718 12.6925L6.07358 12.405L5.85394 12.2079L1.20147 8.033L7.27284 7.55177L7.5846 7.52706L7.69881 7.23591L10 1.36925L12.3012 7.23591L12.415 7.52617L12.7258 7.55166L18.7987 8.04981L14.1401 12.2139Z" fill="none" stroke="currentColor"/></svg>`;
          }
        }

        return starsHTML;
      }

      getReviewsHTML(reviews) {
        let reviewsHTML = '';

        Array.from(reviews).forEach((review) => {
          reviewsHTML += `
            <div class="product-quick-add__reviews-slide swiper-slide">
              <div class="product-quick-add__review-header">
                <div class="product-quick-add__review-icon">
                  <img src="https://cdn.shopify.com/s/files/1/1543/8719/files/Group_2.png?v=1695040413" alt="Yotpo Review Icon">
                </div>
                <div class="product-quick-add__review-author">
                  ${review.user.displayName}
                </div>
                <div class="product-quick-add__review-verified">
                  Verified Buyer
                </div>
                <div class="product-quick-add__review-rating">
                  ${this.getStarsHTML(review.score)}
                </div>
              </div>
              <div class="product-quick-add__review-title">
                ${review.title ?? ''}
              </div>
              <div class="product-quick-add__review-content">
                ${review.content}
              </div>
            </div>
          `;
        });

        return reviewsHTML;
      }

      roundRating(value) {
        const rounded = Math.round(value * 2) / 2;
        return rounded;
      }

      async getReviewsData() {
        // in case id is in this format "gid://shopify/Product/[id]", extract id from the end
        const id = String(this.dataset.productId).split("/").pop();

        // v3 is the API the PDP and product card star widgets use, so the count includes
        // reviews shared through Yotpo product groups (v1 only counts this product's own)
        const url = `https://api-cdn.yotpo.com/v3/storefront/store/0fAhDCSLfKiSUCTvZm1wucV1WrUtO7XzPPD1XX3O/product/${id}/reviews?page=1&perPage=6`;

        try {
          const response = await fetch(url, {
            method: "GET",
            headers: { Accept: "application/json" }
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          return data;
        } catch (e) {
          console.log("==>> error <<==", e.message);
        }
      }
    },
  );
}

if (!customElements.get('quick-add-variant-selects')) {
  customElements.define(
    'quick-add-variant-selects',
    class QuickAddVariantSelects extends HTMLElement {
      constructor() {
        super();

        this.productInfo = this.closest('.product-quick-add-info');

        this.addEventListener('change', (event) => {
          this.onVariantChange(event);
        });
      }

      connectedCallback() {
        this.querySelectorAll('.product-quick-add__form-select').forEach((select) => {
          const selectLabel = select.querySelector('.product-quick-add__form-select-label');
          selectLabel?.addEventListener('click', () => {
            select.classList.toggle('open');
          });

          const inputs = select.querySelectorAll('input[type="radio"]');
          inputs.forEach((input) => {
            input.addEventListener('click', () => {
              select.classList.remove('open');
              select.querySelector('[data-input-select-value]').classList.add('is-selected');
              select.querySelector('[data-input-select-value]').textContent = `${input.value}`;
            });
          });      
        });
      }

      onVariantChange(event) {
        this.updateSelectionMetadata(event);
        this.updateOptions();
        this.updateMasterId();
        this.updateInventoryStatus();
        this.updateShippingInformation();
        this.updateButton();
        this.updateVariantStatuses();

        if (this.currentVariant) {
          this.updateVariantInput();
          this.updatePrice();
        }
      }

      updateSelectionMetadata({ target }) {
        const selectedSwatchValue = target.closest(`.product-quick-add__form-input`).querySelector('[data-selected-value]');
        if (selectedSwatchValue) selectedSwatchValue.innerHTML = target.value;
      }

      updateOptions() {
        this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
          if (element.tagName === 'SELECT') {
            return element.value;
          }
          if (element.tagName === 'FIELDSET') {
            return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
          }
        });
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateVariantInput() {
        const productForm = this.productInfo.querySelector('.quick-add-product-form');
        if (!productForm) return;
        
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(
          (variant) => this.querySelector(':checked').value === variant.option1
        );
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
          if (index === 0) return;
          const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
          const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }
    
      setInputAvailability(elementList, availableValuesList) {
        elementList.forEach((element) => {
          const value = element.getAttribute('value');
          const availableElement = availableValuesList.includes(value);

          element.disabled = !availableElement;
        });
      }

      updatePrice() {
        const priceEls = this.productInfo.querySelectorAll('.product-quick-add__price');
        const { price, compare_at_price } = this.currentVariant;
        priceEls.forEach((priceEl) => {
          let formattedPrice = formatMoney(price, window.moneyFormat).replace(/\.00$/, '');
          let formattedComparePrice = formatMoney(compare_at_price, window.moneyFormat).replace(/\.00$/, '');
          
          // Add currency code if enabled
          if (window.currencyCodeEnabled && window.cartCurrency) {
            formattedPrice = formattedPrice + ' ' + window.cartCurrency.code;
            formattedComparePrice = formattedComparePrice + ' ' + window.cartCurrency.code;
          }
          
          priceEl.innerHTML = `<span class="${compare_at_price > price ? 'price-sale' : ''}">${formattedPrice}</span>`;

          if (compare_at_price > price) {
            priceEl.innerHTML += `<s>${formattedComparePrice}</s>`;
          }
        });
      }

      updateInventoryStatus() {
        const inventoryStatusEls = this.productInfo.querySelectorAll('.variant-inventory__message');

        if (!this.currentVariant) {
          inventoryStatusEls.forEach((inventoryStatus) => {
            inventoryStatus.classList.add('hidden');
          });
          return;
        }

        const { available, inventory_quantity } = this.currentVariant;
        // Per-variant future date from the same JSON used by updateShippingInformation
        const shippingInfoData = JSON.parse(this.querySelector('[data-shipping-information]')?.textContent || '{"text":"","variants":[]}');
        const shippingInfo =
          shippingInfoData.variants?.find((variant) => variant.id === this.currentVariant.id && variant.text !== '') ||
          shippingInfoData;
        const hasFutureShippingDate = Boolean(shippingInfo?.text);

        inventoryStatusEls.forEach((inventoryStatus) => {
          const showSuccessMessage = inventoryStatus.dataset.showSuccessMessage === 'true';
          inventoryStatus.dataset.hasFutureShippingDate = String(hasFutureShippingDate);
          inventoryStatus.classList.remove('success', 'warning', 'hidden');
          inventoryStatus.textContent = '';

          if (available && inventory_quantity > 0) {
            if (inventory_quantity > 10) {
              inventoryStatus.classList.add('success');

              if (showSuccessMessage) {
                if (hasFutureShippingDate) {
                  inventoryStatus.textContent = window.variantStrings.availableForPurchase || 'Available for Purchase';
                } else {
                  inventoryStatus.textContent = 'In Stock, Ready To Ship!';
                }
              }
            } else {
              inventoryStatus.classList.add('warning');
              inventoryStatus.textContent = `Only ${inventory_quantity} left in stock!`;
            }
          } else {
            inventoryStatus.classList.add('warning');
            inventoryStatus.textContent = 'Out of Stock';
          }
        });
      }

      updateShippingInformation() {
        const shippingInfoData = JSON.parse(this.querySelector('[data-shipping-information]')?.textContent || '[]');
        const shippingInfo = shippingInfoData.variants.find((variant) => variant.id === this.currentVariant.id && variant.text !== '') || shippingInfoData;

        const shippingInfoInput = this.productInfo.querySelector('[name="properties[Shipping Info]"]');
        if (shippingInfoInput) shippingInfoInput.value = shippingInfo?.text;

        const shippingInfoEls = this.productInfo.querySelectorAll('.product-shipping-message');
        shippingInfoEls.forEach((ShippingInfo) => {
          if (!this.currentVariant) {
            ShippingInfo.classList.add('hidden');
            ShippingInfo.textContent = '';
          } else {
            ShippingInfo.classList.toggle('hidden', shippingInfo?.text == '');
            ShippingInfo.textContent = shippingInfo?.text;
          }
        });
      }

      updateButton() {
        const productForm = this.productInfo.querySelector('.quick-add-product-form');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        addButton.classList.remove('hidden');

        if (!this.currentVariant) {
          addButton.setAttribute('disabled', 'disabled');
          addButtonText.textContent = window.variantStrings.addToCart;
        } else if (this.currentVariant.available) {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = window.variantStrings.addToCart;
        } else {
          addButton.setAttribute('disabled', 'disabled');
          addButtonText.textContent = window.variantStrings.soldOut;
        }
      }

      getVariantData() {
        this.variantData = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
        return this.variantData;
      }

      getCurrentVariant() {
        this.updateOptions();
        
        return this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }
    }
  );
}

if (!customElements.get('quick-add-lengths')) {
  customElements.define(
    'quick-add-lengths',
    class QuickAddLengths extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const buttons = this.querySelectorAll('.product-quick-add__length-button');
        buttons.forEach((button) => {
          button.addEventListener('click', this.renderContent.bind(this));
        });
      }

      renderContent({ target }) {
        let productPageUrl  = target.getAttribute('data-product-url');

        if (productPageUrl) {
          const urlSeparator = productPageUrl.includes('?') ? '&' : '?';
          productPageUrl = `${productPageUrl}${urlSeparator}section_id=product-quick-add-info`;
        }

        fetch(productPageUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-quick-add-info') || responseHTML.querySelector('product-info');
            
            const modalContent = this.closest('[id^="QuickAddInfo-"]');
            HTMLUpdateUtility.setInnerHTML(modalContent, productElement.outerHTML);
          })
          .catch((error) => {
            console.error('Error fetching product page:', error);
          });
      }
    }
  );
}